function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import PropTypes from 'prop-types';
import React, { memo, useContext } from 'react';
import styled from 'styled-components';
import { boxShadow, top } from 'styled-system';
import Box from './Box';
import { DropdownContext } from './Dropdown';
const StyledDropdownContent = styled(Box).withConfig({
  displayName: "DropdownContent__StyledDropdownContent",
  componentId: "sc-1vl8fjm-0"
})(["", " ", " position:absolute;right:", ";display:", ";z-index:1001;"], top, boxShadow, props => props.alignRight ? '0' : 'auto', props => props.isDropdownOpen ? 'block' : 'none');
const DropdownContent = /*#__PURE__*/memo(_ref => {
  let {
    children,
    ...props
  } = _ref;
  const {
    isDropdownOpen
  } = useContext(DropdownContext);
  return /*#__PURE__*/React.createElement(StyledDropdownContent, _extends({
    isDropdownOpen: isDropdownOpen
  }, props), children);
});
DropdownContent.propTypes = {
  ...top.propTypes,
  ...boxShadow.propTypes,
  ...Box.propTypes,
  alignRight: PropTypes.bool
};
DropdownContent.defaultProps = {
  top: 'auto',
  boxShadow: 'hover'
};
DropdownContent.displayName = 'DropdownContent';
export default DropdownContent;